import * as React from "react";
import { useState, useEffect } from "react";
import logo from "../../assets/spero_logo_new.png";
import "./Login.css";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Alert from "@mui/material/Alert";
import InputBase from "@mui/material/InputBase";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import user from "../../assets/user.png";
import key from "../../assets/key.png";
import { useAuth } from "../Context/ContextAPI";
import { useCall } from "../Context/CallContext";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { API_URL } from "../Config/api";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PhoneForwardedIcon from "@mui/icons-material/PhoneForwarded";
import { motion } from "framer-motion";

export default function Loginextentions() {
  const { handleAuth } = useAuth();
  const { connectSocket } = useCall();
  const [login, setLogin] = useState({
    clg_ref_id: "",
    password: "",
    extensions: "",
  });
  const [extensionsList, setExtensionsList] = useState([]);
  const [extensionError, setExtensionError] = useState(false);
  const [userIdError, setUserIdError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  // Alerts States
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showExistErrorAlert, setShowExistErrorAlert] = useState(false);
  const [showExistErrorAlert1, setShowExistErrorAlert1] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);
  const [showExtAlert, setShowExtAlert] = useState(false);
  const [showExtRequiredAlert, setShowExtRequiredAlert] = useState(false);
  const [showHdOnlyAlert, setShowHdOnlyAlert] = useState(false);
  const [showSelect1111Alert, setShowSelect1111Alert] = useState(false);
  const [showTimeoutAlert, setShowTimeoutAlert] = useState(false);
  const [showNetworkDownAlert, setShowNetworkDownAlert] = useState(false);
  const [customAlert, setCustomAlert] = useState(""); // <-- Naya state Admin/108 alerts ke liye

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [isHdUser, setIsHdUser] = useState(false);

  const navigate = useNavigate();

useEffect(() => {
  const fetchExtensions = async () => {
    if (!login.clg_ref_id.trim()) {
      setExtensionsList([]);
      return;
    }

    try {
      const response = await fetch(
        `${API_URL}/web/extenstion_get/?clg_ref_id=${login.clg_ref_id}`,
      );
      const data = await response.json();

      
      if (Array.isArray(data)) {
        setExtensionsList(data);
      } else if (data && data.extensions && Array.isArray(data.extensions)) {
        
        setExtensionsList(data.extensions);
      } else {
        setExtensionsList([]); 
      }
    } catch (error) {
      console.error("Error fetching extensions:", error);
      setExtensionsList([]); 
    }
  };

  fetchExtensions();
}, [login.clg_ref_id]);

  const handleChange = async (e) => {
    e.preventDefault();


    const isIdEmpty = !login.clg_ref_id || login.clg_ref_id.trim() === "";
    const isPassEmpty = !login.password || login.password.trim() === "";
    const isExtEmpty =
      !login.extensions || String(login.extensions).trim() === "";

    setUserIdError(isIdEmpty);
    setPasswordError(isPassEmpty);
    setExtensionError(isExtEmpty);


    if (isIdEmpty || isPassEmpty || isExtEmpty) {
      return;
    }

    const userId = login.clg_ref_id.trim().toLowerCase();
    const selectedExt = String(login.extensions).trim();

    // 2. Admin Validation (Pre-API Call Check)
    if (userId === "admin" && selectedExt !== "1111") {
      setCustomAlert("For Admin login, please select extension 1111");
      setTimeout(() => setCustomAlert(""), 4000);
      return;
    }

    if (isHdUser && selectedExt === "") {
      setExtensionError(true);
      return;
    }

    setLoading(true);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    try {

      const currentUrl = window.location.href;
      let isCloudValue = "True"; // Default


      if (
        currentUrl.includes("192.168.1.109:8000") ||
        currentUrl.includes("localhost")
      ) {
        isCloudValue = "False";
      } else {

        isCloudValue = selectedExt === "1111" ? "False" : "True";
      }

      console.log(
        "Current URL:",
        currentUrl,
        "| Sending is_cloud:",
        isCloudValue,
      );

      const response = await fetch(`${API_URL}/web/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          clg_ref_id: login.clg_ref_id,
          password: login.password,
          extension_no: login.extensions || "",
          is_cloud: isCloudValue,
        }),
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      // 4. Error Handling Blocks
      if (response.status >= 500) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowSelect1111Alert(true);
          setTimeout(() => setShowSelect1111Alert(false), 5000);
        }
        setLoading(false);
        return;
      }

      if (response.status === 401) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowExistErrorAlert1(true);
          setTimeout(() => setShowExistErrorAlert1(false), 3000);
        }
        setLoading(false);
        return;
      } else if (response.status === 404) {
        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowErrorAlert(true);
          setTimeout(() => setShowErrorAlert(false), 3000);
        }
        setLoading(false);
        return;
      } else {
        const data = await response.json();

        // Specific Backend Messages Handling
        if (data.msg === "Extension login allowed only for HD users") {
          setShowHdOnlyAlert(true);
          setTimeout(() => setShowHdOnlyAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension is required for HD users") {
          setIsHdUser(true);
          setShowExtRequiredAlert(true);
          setExtensionError(true);
          setLoading(false);
          return;
        }

        if (data.msg === "Extension already logged in with another user") {
          setShowExtAlert(true);
          setTimeout(() => setShowExtAlert(false), 4000);
          setLoading(false);
          return;
        }

        if (data.msg === "User Already Logged In. Please check.") {
          setShowExistErrorAlert(true);
          setTimeout(() => setShowExistErrorAlert(false), 3000);
        } else {
          // ==============================
          // LOGIN SUCCESS & ROUTING
          // ==============================
          setSuccessAlert(true);

          localStorage.setItem("loginTime", Date.now());

          // Start 8 hour logout timer
          const EIGHT_HOURS = 8 * 60 * 60 * 1000;

          // Storage setup
          localStorage.setItem("selected_extension", login.extensions);
          localStorage.setItem("token", data.token.access);
          localStorage.setItem("refresh", data.token.refresh);
          localStorage.setItem(
            "user-image",
            data.token.colleague.profile_photo_path,
          );
          localStorage.setItem("user-name", data.token.colleague.first_name);
          localStorage.setItem("user-lname", data.token.colleague.last_name);
          localStorage.setItem("user-email", data.token.colleague.email);
          localStorage.setItem("user-phone", data.token.colleague.phone_no);
          localStorage.setItem("user-loc", data.token.colleague.address);
          localStorage.setItem(
            "user-designation",
            data.token.colleague.designation,
          );
          localStorage.setItem("clg_id", data.token.colleague.id);
          localStorage.setItem("hospitalId", data.token.colleague.clg_hosp_id);
          localStorage.setItem("clgrefId", data.token.colleague.clg_ref_id);
          localStorage.setItem("user_group", data.token.user_group);
          localStorage.setItem(
            "permissions",
            JSON.stringify(data.token.permissions),
          );
          localStorage.setItem("companyID", data.token.colleague.prof_compny);

          // Socket connection
          if (
            data.token.user_group === "hd" &&
            login.extensions &&
            String(login.extensions) !== "1111"
          ) {
            connectSocket(login.extensions);
          }

          // Role-based routing
          setTimeout(() => {
            const group = data.token.user_group;
            handleAuth(); // App level auth context update

            if (group === "hd") navigate("/dashboard");
            else if (group === "HR") navigate("/hr/manage profiles");
            else if (group === "M_DASH") navigate("/MM2Dashboard");
            else if (group === "HR Partner")
              navigate("/hr partner/manage professionals");
            else if (group === "ADMIN") navigate("/hhc/dashboard");
            else if (group === "ACCOUNT") navigate("/hhc/account/dashboard");
            else if (group === "REPORTS") navigate("/reports/dashboard");
            else if (group === "HOSPITAL") navigate("/hospital/dashboard");
            else if (group === "ATTENDANCE")
              navigate("/attendance/attendance-view");
            else if (group === "MANAGEMENT")
              navigate("/management/management-dashboard");
            else if (group === "clincal_gov") navigate("/hhc/clinical/closure");
            else if (group === "HHC_Analytics") navigate("/analytics/home");
            else if (group === "physio") navigate("/physio");
            else if (group === "physioMilestone") navigate("/physioMilestone");
            else if (group === "Consultant")
              navigate("/hhc/consultant/referred patient details");

            window.location.reload();
          }, 2000);
        }
      }
    } catch (error) {
      if (error.name === "AbortError") {
        setShowTimeoutAlert(true);
        setTimeout(() => setShowTimeoutAlert(false), 5000);
      } else {

        if (userId === "108" && selectedExt !== "1111") {
          setCustomAlert("Please select extension 1111 for 108 login");
          setTimeout(() => setCustomAlert(""), 4000);
        } else {
          setShowNetworkDownAlert(true);
          setTimeout(() => setShowNetworkDownAlert(false), 5000);
        }
      }
    } finally {
      setLoading(false);
    }
  };
  const onchange = (e) => {
    const { name, value } = e.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
    if (name === "clg_ref_id") setUserIdError(false);
    if (name === "password") setPasswordError(false);
    if (name === "extensions") setExtensionError(false);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.15, delayChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 120, damping: 12 },
    },
  };

  return (
    <div className="container">
      <motion.div
        className="input_fields"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {!isSmallScreen && (
          <motion.div
            variants={itemVariants}
            style={{ display: "flex", justifyContent: "center" }}
          >
            <img
              src={logo}
              alt="Logo"
              style={{
                height: "110px",
                width: "160px",
                borderRadius: "8px",
                marginBottom: "16px",
              }}
            />
          </motion.div>
        )}

        {/* Dynamic Custom Alert for Admin/108 */}
        {customAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            {customAlert}
          </Alert>
        )}

        {/* Existing Alerts */}
        {showTimeoutAlert && (
          <Alert severity="warning" variant="filled" sx={{ mt: 2 }}>
            Request timed out.
          </Alert>
        )}
        {showNetworkDownAlert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Server connection failed.
          </Alert>
        )}
        {showSelect1111Alert && (
          <Alert severity="error" variant="filled" sx={{ mt: 2 }}>
            Extension unavailable.
          </Alert>
        )}
        {successAlert && (
          <Alert severity="success" variant="filled">
            Login Successful!
          </Alert>
        )}
        {showErrorAlert && (
          <Alert severity="error" variant="filled">
            Invalid ID or Password!
          </Alert>
        )}
        {showExistErrorAlert && (
          <Alert severity="error" variant="filled">
            User already logged in!
          </Alert>
        )}
        {showExtAlert && (
          <Alert severity="warning" variant="filled">
            Extension already in use!
          </Alert>
        )}

        {/* User ID Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 1,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: userIdError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={user}
              alt=""
              style={{ height: "18px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="Enter User ID"
              name="clg_ref_id"
              value={login.clg_ref_id}
              onChange={onchange}
              required
            />
          </Box>
          {userIdError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              User ID required*
            </Typography>
          )}
        </motion.div>

        {/* Password Field */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: passwordError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <img
              src={key}
              alt=""
              style={{ height: "20px", marginLeft: "8px" }}
            />
            <InputBase
              sx={{ ml: 1.2, flex: 1 }}
              placeholder="Enter Password"
              type={showPassword ? "text" : "password"}
              name="password"
              value={login.password}
              onChange={onchange}
              required
            />
            <Button
              onClick={() => setShowPassword(!showPassword)}
              size="small"
              startIcon={showPassword ? <VisibilityOff /> : <Visibility />}
            />
          </Box>
          {passwordError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              Password required*
            </Typography>
          )}
        </motion.div>

        {/* Extension Select */}
        <motion.div variants={itemVariants}>
          <Box
            className="input-box"
            sx={{
              mt: 3,
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              height: "2.5rem",
              borderRadius: "6px",
              border: extensionError ? "1px solid #d32f2f" : "1px solid #000",
            }}
          >
            <PhoneForwardedIcon
              sx={{
                fontSize: "18px",
                ml: 1,
                color: extensionError ? "#d32f2f" : "black",
              }}
            />
            <Select
              displayEmpty
              name="extensions"
              value={login.extensions}
              onChange={onchange}
              sx={{
                ml: 1,
                flex: 1,
                height: "100%",
                ".MuiOutlinedInput-notchedOutline": { border: 0 },
              }}
            >
              <MenuItem value="" disabled>
                Select Extension
              </MenuItem>

              {Array.isArray(extensionsList) &&
                extensionsList.map((ext, index) => (
                  <MenuItem key={index} value={ext}>
                    {ext}
                  </MenuItem>
                ))}
            </Select>
          </Box>
          {extensionError && (
            <Typography
              variant="caption"
              color="error"
              sx={{ ml: 1, mt: 0.5, display: "block" }}
            >
              Extension required*
            </Typography>
          )}
        </motion.div>

        {/* Submit Button */}
        <motion.div
          variants={itemVariants}
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Button
            variant="contained"
            sx={{
              mt: 6,
              width: "100%",
              maxWidth: "28ch",
              height: "7vh",
              backgroundColor: "#69DAC3",
              color: "black",
            }}
            onClick={handleChange}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </motion.div>

        {/* Footer Links */}
        <motion.div variants={itemVariants}>
          <Box
            sx={{
              mt: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              {[
                "Privacy & Policy",
                "Refund & Cancellation",
                "Contact Us",
                "About Us",
              ].map((label, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  sx={{ cursor: "pointer", "&:hover": { color: "#0072BC" } }}
                >
                  {label}
                </Typography>
              ))}
            </Box>
          </Box>
        </motion.div>
      </motion.div>
    </div>
  );
}
